import './App.css';
import React, { useEffect, useMemo } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import LoginPage from './pages/LoginPage';
// import RegisterPage from './pages/RegisterPage'; // Temporarily disabled: registration flow
import DashboardPage from './pages/DashboardPage';
import ProfilePage from './pages/ProfilePage';
import BranchManagementPage from './pages/BranchManagementPage';
import AgentsPage from './pages/AgentsPage';
import ProductSetupPage from './pages/ProductSetupPage';
import SalesPage from './pages/SalesPage';
import CollectionsPage from './pages/CollectionsPage';
import CommissionsPage from './pages/CommissionsPage';
import FinancePage from './pages/FinancePage';
import AdminPage from './pages/AdminPage';
import ReportsPage from './pages/ReportsPage';
import ProtectedRoute from './components/ProtectedRoute';
import AppLayout from './components/AppLayout';
import ModulePlaceholderPage from './pages/ModulePlaceholderPage';
import {
  APP_NAV_ITEMS,
  canAccessNavItem,
  getAccessibleNavItems,
} from './navigation/appNavigation';

function renderModuleRoute(item) {
  if (item.path === '/dashboard') {
    return <DashboardPage />;
  }

  if (item.path === '/branch-admin') {
    return <BranchManagementPage />;
  }

  if (item.path === '/agents') {
    return <AgentsPage />;
  }

  if (item.path === '/product-setup') {
    return <ProductSetupPage />;
  }

  if (item.path === '/sales') {
    return <SalesPage />;
  }

  if (item.path === '/collections') {
    return <CollectionsPage />;
  }

  if (item.path === '/commissions') {
    return <CommissionsPage />;
  }

  if (item.path === '/finance') {
    return <FinancePage />;
  }

  if (item.path === '/admin') {
    return <AdminPage />;
  }

  if (item.path === '/reports') {
    return <ReportsPage />;
  }

  return (
    <ModulePlaceholderPage
      eyebrow={item.eyebrow}
      title={item.label}
      description={item.description}
    />
  );
}

function AppRoutes() {
  const { isAuthenticated, user } = useAuth();
  const userScopes = Array.isArray(user?.scopes) ? user.scopes : [];
  const accessibleNavItems = useMemo(
    () => getAccessibleNavItems(userScopes),
    [userScopes]
  );
  const fallbackPath = accessibleNavItems[0]?.path || '/dashboard';

  return (
    <Routes>
      <Route
        path="/"
        element={<Navigate to={isAuthenticated ? fallbackPath : '/login'} replace />}
      />
      <Route path="/login" element={<LoginPage />} />
      {/* <Route path="/register" element={<RegisterPage />} /> */}
      <Route
        element={(
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        )}
      >
        {APP_NAV_ITEMS.map((item) => (
          <Route
            key={item.path}
            path={item.path}
            element={
              canAccessNavItem(userScopes, item)
                ? renderModuleRoute(item)
                : <Navigate to={fallbackPath} replace />
            }
          />
        ))}
        <Route path="/profile" element={<ProfilePage />} />
      </Route>
      <Route
        path="*"
        element={(
          <Navigate to={isAuthenticated ? fallbackPath : '/login'} replace />
        )}
      />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    // Hide FinDesk loading screen when React app mounts
    if (window.hideFinDeskLoader) {
      window.hideFinDeskLoader();
    }
  }, []);

  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
